var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.142,
    height: 14.142
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.728 0L7.072 5.656 1.414 0 0 1.414 5.657 7.07 0 12.728l1.414 1.414 5.658-5.657 5.656 5.657 1.414-1.414L8.485 7.07l5.657-5.656z",
    fill: "#777"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC4xNDIiIGhlaWdodD0iMTQuMTQyIiB2aWV3Qm94PSIwIDAgMTQuMTQyIDE0LjE0MiI+CiAgPHBhdGggaWQ9IkNsb3NlIiBkPSJNMTIuNzI4LDAsNy4wNzIsNS42NTYsMS40MTQsMCwwLDEuNDE0LDUuNjU3LDcuMDcsMCwxMi43MjhsMS40MTQsMS40MTRMNy4wNzIsOC40ODVsNS42NTYsNS42NTcsMS40MTQtMS40MTRMOC40ODUsNy4wN2w1LjY1Ny01LjY1NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiIGZpbGw9IiM3NzciLz4KPC9zdmc+Cg==";
export { SvgClose2 as ReactComponent };